import { PropertyDetailsType } from '@/interfaces/property';

export type PropertyDetailAction =
  | { kind: 'directions'; googleMapsUrl: string }
  | { kind: 'contact' }
  | { kind: 'overlay' };

export function resolvePropertyDetailAction(
  type: PropertyDetailsType,
  coordinates: { lat: number; lon: number } | undefined
): PropertyDetailAction | null {
  switch (type) {
    case PropertyDetailsType.Directions:
      if (
        coordinates &&
        Number.isFinite(coordinates.lat) && coordinates.lat >= -90 && coordinates.lat <= 90 &&
        Number.isFinite(coordinates.lon) && coordinates.lon >= -180 && coordinates.lon <= 180
      ) {
        const lat = encodeURIComponent(String(coordinates.lat));
        const lon = encodeURIComponent(String(coordinates.lon));
        return {
          kind: 'directions',
          googleMapsUrl: `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`,
        };
      }
      return null;
    case PropertyDetailsType.Contact:
      return { kind: 'contact' };
    case PropertyDetailsType.Info:
      return { kind: 'overlay' };
    default:
      return null;
  }
}